// extracted by mini-css-extract-plugin
export default {"module":"calendar_module__EI44H"};